/**
 * Member onboarding (**v7-only**): step keys and the version guard.
 * Owner reference: `apps/owner/src/constants/onboarding.ts`.
 */

/** `staleTime` for the member onboarding queries on `/my/onboarding` (reduces duplicate refetch vs global defaults). */
export const MEMBER_ONBOARDING_QUERY_STALE_MS = 60_000;

export const ONBOARDING_STEP = {
  WELCOME: "WELCOME",
  GET_STARTED: "GET_STARTED",
  SHARE_AVAILABILITY: "SHARE_AVAILABILITY",
  SHARE_TODO: "SHARE_TODO",
  /**
   * After **My list**, backend advances here; progress continues on **Home** via
   * `onboardingWidget` (Virtual Onboarding Session, etc.) — not full-screen `/my/onboarding`.
   * @see platform `onboarding-widget.repository.ts` (`ONBOARDING_SESSION`)
   */
  BOOK_ONBOARDING: "BOOK_ONBOARDING",
  BUILD_LIST: "BUILD_LIST",
  ONBOARDING_SESSION: "ONBOARDING_SESSION",
} as const;

/** Steps that use the Home “Getting started” widget instead of this route. */
export function isWidgetPhaseOnboardingStep(
  step: string | null | undefined,
): boolean {
  if (!step) return false;
  return ![
    ONBOARDING_STEP.WELCOME,
    ONBOARDING_STEP.GET_STARTED,
    ONBOARDING_STEP.SHARE_AVAILABILITY,
    ONBOARDING_STEP.SHARE_TODO,
    ONBOARDING_STEP.BOOK_ONBOARDING,
    ONBOARDING_STEP.BUILD_LIST,
  ].includes(step as any);
}

/**
 * v7 uses REST onboardings + orders list-items APIs (`OnboardingV7`) and is the ONLY
 * supported version — the GraphQL-backed v6.x flow was deleted with the GraphQL sunset,
 * so members below v7 get no onboarding shell at all.
 */
export function isOnboardingV7Version(
  version: number | null | undefined,
): boolean {
  if (version == null) return false;
  return Number(version) === 7;
}
